
export function getCurrentTime(): [string, string] {
  const d = new Date()
  const h = d.getHours().toString()
  const m = d.getMinutes()
  return [h, (m < 10 ? '0' : '') + m]
}
